<template>
  <!-- Breadcrumb -->
  <v-row>
    <v-col cols="12">
      <v-breadcrumbs
        class="text-caption py-0 px-0"
        :items="viewModel.breadcrumbs"
      >
        <template v-slot:prepend>
          <v-icon icon="mdi-chart-bar" size="small"></v-icon>
        </template>
      </v-breadcrumbs>
    </v-col>
  </v-row>

  <!-- Información del Ahorro -->
  <v-row>
    <!-- Columna 1: Tipo de Ahorro -->
    <v-col cols="12" md="6">
      <v-list style="border-left: 7px solid rgb(var(--v-theme-primary), 0.4)">
        <v-list-item class="rounded-sm pa-4">
          <template #default>
            <v-list-item-title
              class="text-subtitle-1 font-weight-bold"
              style="white-space: normal"
            >
              {{ viewModel.saving.value?.TIPO_AHORRO }}
            </v-list-item-title>
            <v-list-item-subtitle style="white-space: normal">
              <p class="text-subtitle-1">
                <strong>ID de Ahorro: </strong>
                <span class="ml-4">{{ viewModel.saving.value?.idahorro }}</span>
              </p>
            </v-list-item-subtitle>
          </template>
        </v-list-item>
      </v-list>
    </v-col>

    <!-- Columna 2: Ahorro Disponible -->
    <v-col cols="12" md="6">
      <v-list style="border-left: 7px solid rgb(var(--v-theme-primary), 0.4)">
        <v-list-item class="rounded-sm pa-4">
          <template #default>
            <v-list-item-title class="text-subtitle-1 font-weight-bold">
              Ahorro Disponible
            </v-list-item-title>
            <v-list-item-subtitle style="white-space: normal">
              <p class="text-subtitle-1 text-primary font-weight-bold">
                {{ viewModel.formatCoin(viewModel.saving.value?.moneda) }}
                {{ viewModel.formatFloat(viewModel.saving.value?.saldo) }}
              </p>
            </v-list-item-subtitle>
          </template>
        </v-list-item>
      </v-list>
    </v-col>
  </v-row>

  <!--Deatelle y  Movimientos -->
  <v-row class="mt-4">
    <v-col cols="12" md="6">
      <v-card class="pa-4 rounded-sm" flat border>
        <v-card-title class="text-subtitle-1 font-weight-bold px-0">
          Detalle de Ahorro
        </v-card-title>
        <v-divider></v-divider>
        <v-container fluid class="px-0">
          <v-row>
            <v-col cols="6">
              <span class="text-subtitle-1">TREA</span>
            </v-col>
            <v-col cols="6" class="text-right">
              <span class="text-subtitle-1 font-weight-bold">
                {{ viewModel.formatFloat(viewModel.saving.value?.tea) }}%
              </span>
            </v-col>

            <v-col cols="6">
              <span class="text-subtitle-1">Plazo</span>
            </v-col>
            <v-col cols="6" class="text-right">
              <span class="text-subtitle-1 font-weight-bold">
                {{ viewModel.saving.value?.plazo }} días
              </span>
            </v-col>

            <v-col cols="6">
              <span class="text-subtitle-1">Fecha de Apertura</span>
            </v-col>
            <v-col cols="6" class="text-right">
              <span class="text-subtitle-1 font-weight-bold">
                {{
                  viewModel.formatDate(viewModel.saving.value?.fechaapertura)
                }}
              </span>
            </v-col>

            <v-col cols="6">
              <span class="text-subtitle-1">Fecha de Vencimiento</span>
            </v-col>
            <v-col cols="6" class="text-right">
              <span class="text-subtitle-1 font-weight-bold">
                <span v-if="!viewModel.saving.value?.fechavencimiento"
                  >---</span
                >
                <span v-else>{{
                  viewModel.formatDate(viewModel.saving.value?.fechavencimiento)
                }}</span>
              </span>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-col>
    <v-col cols="12" md="6">
      <v-card class="pa-4 rounded-sm" flat border>
        <v-card-title class="text-subtitle-1 font-weight-bold px-0">
          Movimientos
        </v-card-title>
        <v-divider></v-divider>

        <!-- Estado de Carga -->
        <div v-if="viewModel.loadingMovements.value" class="text-center">
          <v-progress-circular
            indeterminate
            color="primary"
            size="30"
          ></v-progress-circular>
          <p class="text-caption mt-2">Cargando movimientos...</p>
        </div>

        <!-- Lista de Movimientos -->
        <div v-else>
          <v-alert
            v-if="viewModel.movements.value.length === 0"
            type="info"
            class="text-center text-subtitle-2"
            variant="tonal"
            text="Actualmente no tienes movimientos."
            border
          >
          </v-alert>
          <v-list v-else class="overflow-y-auto" max-height="215">
            <v-list-item
              v-for="(mov, idx) in viewModel.movements.value"
              :key="'mov-' + idx"
              class="pa-4 mb-2"
              border
              style="border-left: 7px solid rgb(var(--v-theme-primary), 0.4)"
            >
              <template #prepend>
                <v-avatar
                  rounded="lg"
                  size="48"
                  variant="tonal"
                  :color="viewModel.getColor(mov.tipomov)"
                >
                  <v-icon size="20">{{
                    viewModel.getIconName(mov.tipomov)
                  }}</v-icon>
                </v-avatar>
              </template>
              <template #default>
                <v-list-item-title
                  class="text-subtitle-1 font-weight-bold text-truncate pr-10"
                >
                  {{ mov.concepto }}
                </v-list-item-title>
                <v-list-item-subtitle class="text-subtitle-2">
                  {{ viewModel.formatDate(mov.fecharegistro) }}
                </v-list-item-subtitle>
              </template>
              <template #append>
                <span
                  class="text-subtitle-1 font-weight-bold"
                  :class="`text-${viewModel.getColor(mov.tipomov)}`"
                >
                  {{ viewModel.formatCoin(viewModel.saving.value?.moneda) }}
                  {{ viewModel.formatFloat(mov.capital) }}
                </span>
              </template>
            </v-list-item>
          </v-list>
        </div>
      </v-card>
    </v-col>
  </v-row>

  <!-- Información General, Transferencia y Estado de Cuenta -->
  <v-row justify="center" align="stretch">
    <!-- Botón de Solicitar Transferencia -->
    <v-col cols="12" md="6" class="d-flex">
      <v-card class="pa-4 rounded-sm flex-grow-1" flat border>
        <v-card-title
          class="text-subtitle-1 font-weight-bold px-0 text-capitalize"
        >
          Transferencia entre cuentas de Ahorro
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="px-0">
          <!-- Mensaje informativo -->
          <v-alert type="info" variant="tonal" border="start" class="mb-4">
            La transferencia será revisada y validada antes de ser procesada.
          </v-alert>
          <v-btn
            color="primary"
            block
            flat
            variant="tonal"
            class="text-none"
            :loading="viewModel.loadingTransfer.value"
            @click="viewModel.solicitarTransferencia"
          >
            Solicitar Transferencia
          </v-btn>
        </v-card-text>
      </v-card>
    </v-col>

    <!-- Botón de Estado de Cuenta -->
    <v-col cols="12" md="6" class="d-flex">
      <v-card class="pa-4 rounded-sm flex-grow-1" flat border>
        <v-card-title class="text-subtitle-1 font-weight-bold px-0">
          Estado de Cuenta
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="px-0">
          <!-- Selector de Fecha -->
          <v-select
            v-model="viewModel.selectedDate.value"
            :items="viewModel.availableDates.value"
            label="Seleccione un Mes y Año"
            variant="outlined"
            density="compact"
            hide-details
            item-title="label"
            item-value="value"
          />
        </v-card-text>
        <v-btn
          color="secondary"
          block
          flat
          class="text-none"
          :loading="viewModel.loadingEstadoCuenta.value"
          @click="viewModel.getStateOfAccount"
          :disabled="!viewModel.selectedDate"
        >
          Ver Estado de Cuenta
        </v-btn>
      </v-card>
    </v-col>
  </v-row>
  <!-- Diálogo de Estado de Cuenta -->
  <TransferDialog ref="transferDialogRef" />
  <StateOfAccountDialog ref="stateOfAccountDialogRef"></StateOfAccountDialog>
</template>

<script setup lang="ts">
import { ref } from "vue";
import SavingDetailViewModel from "@/viewmodels/app/SavingDetailViewModel";
import TransferDialog from "@/components/dialogs/TransferDialog.vue";
import StateOfAccountDialog from "@/components/dialogs/StateOfAccountDialog.vue";

const transferDialogRef = ref(null);

const stateOfAccountDialogRef = ref(null);
const viewModel = new SavingDetailViewModel(
  transferDialogRef,
  stateOfAccountDialogRef
);
</script>
